import { LacChallenge } from './lac-challenge.model';
import { Language } from '../../shared/projects.model';
import { LacReward } from '../campaign.models';
import { LacTag } from './common.model';

export enum CampaignStatus {
  ACTIVE = 'current_campaign',
  UPCOMING = 'next_campaign',
  NO_CAMPAIGN = 'no_campaign'
}

export interface LacCampaignData {
  reward: LacReward;
  campaign_status: CampaignStatus;
  account_points: number;
  campaign: LacCampaign;
  company: string;
  campaign_total_points: number;
  challenges: LacChallenge[];
  last_week_account_points: number;
  leaderboard: LacUser[];
  teams_leaderboard: any[];
  learning_content: LacCampaignLearningContent[];
  streak: number;
  this_week_account_points: number;
  two_weeks_ago_account_points: number;
  last_week: any[];
  onboarding: boolean;
  badges: any[];
  target: number;
  second_target: number;
  start_date: Language;
  description: Language;
  badges_won: any[];
  teams_only: boolean;
}

export interface LacCampaign {
  name: Language;
  description: Language;
  slug: string;
  start_date: string;
  end_date: string;
  picture_cover: string;
  onboarding_image_1: string;
  onboarding_image_2: string;
  onboarding_intro: Language;
  onboarding_media: string;
  onboarding_media_text: Language;
  company: string;
  topic: Language;
}

export interface LacUser {
  account_id: number;
  name: string;
  points?: number;
  position?: number;
  profile_picture?: string;
  surname?: string;
  current_user?: boolean;
  team_id?: number;
}

export interface LacCampaignLearningContent {
  completed: boolean;
  colleagues_completed : number;
  id: number;
  points: number;
  reading_time: number;
  slug: string;
  start_date: string;
  title: Language;
  type: string;
  subtitle: Language;
  tags: LacTag[];
  end_date: string;
  day_next: number;
}

export interface FeedPost extends LikeableObject {
  datetime: number | string;
  timestamp?: number | string;
  type: string;
  aq_id?: number;
  ar_id?: number;
  ac_id?: number;
  account_id: number;
  account_name: string;
  account_surname: string;
  account_profile_picture: string;
  challenge_id?: number;
  challenge_slug?: string;
  challenge_title?: Language;
  challenge_proof_answer?: string;
  challenge_proof_media?: string;
  challenge_proof_comment?: string;
  challenge_proof_question?: string;
  quiz_id?: number;
  quiz_title?: Language;
  reading_id?: number;
  reading_title?: Language;
  comments: FeedComment[];
  members?: FeedPost[]; // When the feed is private and we get post from here instead
  time_ago?: string; // Frontend only property
  isCommentsBlockOpened?: boolean; // Frontend only property
  readMoreClicked?: boolean; // Frontend only property
  team?: string;
}

export interface TeamFeedPost {
  unique_id: string;
  number_people: number;
  team: Language;
  type: string;
  activity_name: Language;
  timestamp: number;
  time_ago: string;
  members: FeedPost[];
  reading_id?: number;
  quiz_id?: number;
  challenge_id?: number;
  challenge_slug?: string;
}

export interface FeedComment extends LikeableObject {
  comment_id: number;
  account_id: number;
  account_name: string;
  account_surname: string;
  account_profile_picture: string;
  comment: string;
  datetime: number;
  timestamp?: number;
  time_ago: string; // Frontend only property
  isRepliesBlockOpened?: boolean; // Frontend only property
  replies: FeedCommentReply[];
  isContextMenuOpened?: boolean; // Frontend only property
}

export interface FeedCommentReply extends LikeableObject {
  reply_id: number;
  account_id: number;
  account_profile_picture: string,
  name: string;
  surname: string;
  comment: string;
  datetime: number;
  timestamp?: number;
  time_ago: string; // Frontend only property
  isContextMenuOpened?: boolean; // Frontend only property
}

export interface LikeableObject {
  likes: number;
  account_like_ids?: number[];
  account_like?: boolean; // Frontend only property
  likesClickCount?: number; // Frontend only property
  lastLikeClickTime?: number; // Frontend only property
}
